import { type JSX } from "react";
import { ListIllustration } from "vega-illustrations";

import { type AuditEventResponse } from "@vega-api/generated/types/auditEventResponse";
import { CoreTable } from "@vega-core/components/Table/CoreTable/CoreTable";
import { m } from "@vega-core/paraglide/messages";

import { useAuditTableColumns } from "../../hooks/useAuditTableColumns";

type AuditTableProps = {
  data: AuditEventResponse[];
  isLoading?: boolean;
  paginationElement?: JSX.Element | null;
};

export const AuditTable = ({
  data,
  isLoading = false,
  paginationElement,
}: AuditTableProps) => {
  const { columns } = useAuditTableColumns();

  return (
    <CoreTable
      columns={columns}
      data={data}
      dataTestId="audit-table"
      emptyState={{
        title: m.coInvestments_audit_noEvents(),
        illustration: <ListIllustration />,
      }}
      isLoading={isLoading}
      paginationElement={paginationElement}
    />
  );
};
